import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { PerfilRiesgo } from '../../_models/perfil-riesgo';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PerfilRiesgoVariacionCiclo } from '../../_models/perfil-riesgo-variacion-ciclo';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { PerfilRiesgoVariacionCicloService } from '../../_services/perfil-riesgo-variacion-ciclo.service';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { forkJoin } from 'rxjs';
import {Modalidad} from '../../_models/modalidad';
import {ModalidadService} from '../../_services/modalidad.service';
import {Table} from 'primeng/table';

@Component( {
  selector: 'app-perfiles-riesgo-ciclo',
  templateUrl: 'perfiles-riesgo-ciclo.component.html'
} )

export class PerfilesRiesgoCicloComponent implements OnInit {

  @Input() perfil: PerfilRiesgo;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  columnas: any[] = [];
  lisPerfilesRiesgoCiclos: PerfilRiesgoVariacionCiclo[] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  supTasa = false;
  perCicloSeccionado: PerfilRiesgoVariacionCiclo;
  lisCiclos: SelectItem[] = [];
  lisTodosCiclos: ListaItem[] = [];
  lisModalidad: SelectItem[] = [];
  lisTodosModalidad: Modalidad[] = [];
  llaveExiste = false;
  carRiesgoTasa: boolean;
  busqueda: string;
  carTabla: boolean = false;
  @ViewChild('tciclo', { static: true }) tabla: Table;

  constructor( private perRiesgoCicloServicio: PerfilRiesgoVariacionCicloService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private lisServicio: ListaService,
               private fb: FormBuilder,
               private modalidadadServices: ModalidadService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'id', header: this.nav.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreModalidad', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_MODALIDAD' ), sort: false },
      { field: 'cicloPerfilRiesgo', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_CICLO' ), sort: false },
      { field: 'puntosDisminucion', header: this.nav.buscarMensaje( 'PERFILRIESGOCICLO.LBL_PUNTODISMINUCION' ), sort: false },
      { field: 'indicadorSuma', header: this.nav.buscarMensaje( 'PERFILRIESGOTASAS.LBL_INDICADORSUMA' ), sort: false },
      { field: 'indicadorHabilitado', header: this.nav.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.nav.getSearch('perfil-riesgo.component');

    forkJoin( this.lisServicio.getMasterDetails( 'ListasCiclosPerfilesRiesgos' ),
      this.perRiesgoCicloServicio.listadoPorPerfilRiesgo( this.perfil.idPerfilRiesgo ),
      this.modalidadadServices.listadoModalidadesHabilitadas()
    ).subscribe( ( [ lisCiclos, lisPerfilesCiclos, modalidades ] )  => {
      this.lisPerfilesRiesgoCiclos = lisPerfilesCiclos;
      this.cargarFormulario();
      this.lisTodosCiclos = lisCiclos;
      this.cargarItemLista();
      this.lisTodosModalidad = modalidades;

      modalidades.map( ( s: Modalidad ) => {
        this.lisModalidad.push( { label: s.nombre, value: s.idModalidad } );
      } );
      this.carInformacionInicial = false;

      this.carTabla = false;
     // this.tabla.filterGlobal(this.busqueda, 'contains');
    } );
  }

  setBusqueda() {
    this.nav.setSearch('perfil-riesgo.component', this.busqueda);
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPerfilRiesgoVariacionCiclo: [ this.perCicloSeccionado ? this.perCicloSeccionado.idPerfilRiesgoVariacionCiclo : null ],
      puntosDisminucion: [ this.perCicloSeccionado ? this.perCicloSeccionado.puntosDisminucion : null, [ Validators.required, Validators.maxLength( 5 ) ] ],
      idModalidad: [ this.perCicloSeccionado ? this.perCicloSeccionado.idModalidad : null, [ Validators.required ] ],
      idCiclo: [ this.perCicloSeccionado ? this.perCicloSeccionado.idCiclo : null, [ Validators.required ] ],
      idPerfilRiesgo: [ this.perCicloSeccionado ? this.perCicloSeccionado.idPerfilRiesgo : this.perfil.idPerfilRiesgo, [ Validators.required ] ],
      indicadorHabilitado: [ this.perCicloSeccionado ? this.perCicloSeccionado.indicadorHabilitado : true ],
      auditoriaFecha: [ this.perCicloSeccionado ? this.perCicloSeccionado.auditoriaFecha : null ],
      auditoriaUsuario: [ this.perCicloSeccionado ? this.perCicloSeccionado.auditoriaUsuario : null ],
      indicadorSuma: [ this.perCicloSeccionado ? this.perCicloSeccionado.indicadorSuma : false, [ Validators.required ] ]
    } );
  }

  irSiguiente() {
    this.dismiss.emit( 'SCORE' );
  }

  onSubmit() {
    this.submitted = true;
    this.validarLlaveNegocio();
    if ( this.formulario.valid && !this.supTasa && !this.llaveExiste) {
      this.guardando = true;
      this.carRiesgoTasa = true;
      const perRiesgoCiclo = this.formulario.value;
      if ( perRiesgoCiclo.idPerfilRiesgoVariacionCiclo ) {
        this.perRiesgoCicloServicio.actualizar( perRiesgoCiclo ).subscribe( perRiesgoCicloActualizado => {
          const a = this.lisTodosCiclos.find( x => x.idLista === perRiesgoCiclo.idCiclo );
          if ( a ) {
            perRiesgoCiclo.cicloPerfilRiesgo = a.nombre;
          }
          const b = this.lisTodosModalidad.find( x => x.idModalidad === perRiesgoCiclo.idModalidad );
          if ( b ) {
            perRiesgoCiclo.nombreModalidad = b.nombre;
          }
          const indice = this.lisPerfilesRiesgoCiclos.findIndex( x => x.idPerfilRiesgoVariacionCiclo === perRiesgoCiclo.idPerfilRiesgoVariacionCiclo );
          if ( indice >= 0 ) {
            this.lisPerfilesRiesgoCiclos[ indice ] = perRiesgoCiclo;
          }
          this.submitted = false;
          this.perCicloSeccionado = null;
          this.cargarFormulario();
          this.cargarItemLista();
          this.guardando = false;
          this.carRiesgoTasa = false;
          this.nav.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.carRiesgoTasa = false;
          this.nav.setMesage( 3 );
        } );
      } else {
        this.perRiesgoCicloServicio.crear( perRiesgoCiclo ).subscribe( perRiesgoCicloNuevo => {
          perRiesgoCiclo.idPerfilRiesgoVariacionCiclo = perRiesgoCicloNuevo.idPerfilRiesgoVariacionCiclo;
          const a = this.lisTodosCiclos.find( x => x.idLista === perRiesgoCiclo.idCiclo );
          if ( a ) {
            perRiesgoCiclo.cicloPerfilRiesgo = a.nombre;
          }
          const b = this.lisTodosModalidad.find( x => x.idModalidad === perRiesgoCiclo.idModalidad );
          if ( b ) {
            perRiesgoCiclo.nombreModalidad = b.nombre;
          }
          this.lisPerfilesRiesgoCiclos.push( perRiesgoCiclo );
          this.submitted = false;
          this.carRiesgoTasa = false;
          this.guardando = false;
          this.cargarFormulario();
          this.cargarItemLista();
          this.nav.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.carRiesgoTasa = false;
          this.nav.setMesage( 3 );
        } );
      }

    }
  }

  editar( perCiclo: PerfilRiesgoVariacionCiclo ) {
    this.perCicloSeccionado = perCiclo;
    this.cargarFormulario();
    this.cargarItemLista();
    this.submitted = false;
    this.supTasa = false;
  }

  get f() {
    return this.formulario.controls;
  }

  validarTasa() {
    const punDisminucion = Number( this.f.puntosDisminucion.value );
    if(this.f.idModalidad.value){
      const tasa = this.lisTodosModalidad.find(x => x.idModalidad === this.f.idModalidad.value);
      this.supTasa = (punDisminucion > tasa.tasa) ? true : false;
    }else {
      this.supTasa = true;
    }
  }

  cargarItemLista() {
    this.lisCiclos = [];
    this.lisTodosCiclos.map( ( s: ListaItem ) => {
        this.lisCiclos.push( { label: s.nombre, value: s.idLista } );
    } );
  }

  validarLlaveNegocio() {
    const idModalidad = ( this.f.idModalidad.value );
    const idCiclo = this.f.idCiclo.value;
    const idPerfilRiesgoVariacionCiclo = this.f.idPerfilRiesgoVariacionCiclo.value;
    const dato1 = this.lisPerfilesRiesgoCiclos.find( x => x.idCiclo === idCiclo &&
      x.idModalidad === idModalidad);
    if ( dato1 && dato1.idPerfilRiesgoVariacionCiclo !== idPerfilRiesgoVariacionCiclo){
      this.llaveExiste = true;
    } else {
      this.llaveExiste = false;
    }
  }
}
